import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {MyRatingVo} from '../../common/shared/api/gateway/viewer/MyRatingVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 내 평점 조회
 *
 * Origin: pageNicolasApi.getMyRating
 * API: POST /api/v5/store/community/myrating
 */
export async function postStoreCommunityMyrating(
  {
    seriesId,
    productId,
  }: {
    seriesId: number;
    productId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & MyRatingVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/community/myrating',
    {
      method: 'POST',
      data: {
        seriesid: seriesId,
        singleid: productId,
      },
    },
    options
  );
  return response.data;
}
